import React from 'react';
import styles from './LabeledUnitInput.module.less';
import { KompisText } from '@inter-ikea-kompis/react-components';
import { useDispatch, useSelector } from 'react-redux';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import {
  thunkSaveWallHeight,
  thunkSetVirtualKeyboardHeightInput,
} from '../../../state/draft/ceilingHeight/ceilingHeightThunks';
import { selectDraftCeilingHeight } from '../../../state/draft/ceilingHeight/ceilingHeightSelectors';
import { selectUseMetric } from '../../../state/dexfSettings/dexfSettingsSelectors';
import { actionSetDraftCeilingHeight } from '../../../state/draft/ceilingHeight/ceilingHeightActions';
import useKeyboard from '../../../util/useKeyboard';
import { KEYS } from '../../../constants';
import { translate } from '../../../services/L10n';
import { t } from '../../../translations';
import { KeyboardTypeEnum } from '@inter-ikea-kompis/keyboard-manager';

const CeilingInput = () => {
  const dispatch = useDispatch();
  const saveWallHeight = () => dispatch(thunkSaveWallHeight());
  const inputElement = React.useRef<HTMLInputElement | null>(null);

  const draftHeight = useSelector(selectDraftCeilingHeight);
  const useMetricMeasures = useSelector(selectUseMetric);

  const setDraftHeight = (event: any) => {
    const draftHeightRoundedUp =
      event.target.value && Math.ceil(event.target.value);
    dispatch(actionSetDraftCeilingHeight(draftHeightRoundedUp));
  };

  const onBlur = () => {
    inputElement?.current?.blur && inputElement.current.blur();
    saveWallHeight();
    hideKeyboard();
  };

  const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    registerCallbacks({ onDone: onBlur, onKeyPress: onVirtualKeyPress });
    setInputType(KeyboardTypeEnum.number);
    showKeyboard();
    e.target.select();
  };

  const { showKeyboard, hideKeyboard, registerCallbacks, setInputType } =
    useKeyboard;

  const onVirtualKeyPress = (keyCode: string) =>
    dispatch(thunkSetVirtualKeyboardHeightInput(keyCode));

  const handleOnEnter = (e: React.KeyboardEvent<HTMLInputElement>) =>
    e.key === KEYS.ENTER &&
    // @ts-ignore This works, since element is an input. For some reason, typescript disagrees.
    e.target.blur();

  return (
    <div className={styles.CeilingHeightWrapper}>
      <KompisText theme={SkapaTheme} bold={true}>
        {translate(t.CEILING_HEIGHT)}
      </KompisText>

      <div className={styles.unitInputWrapper}>
        <div className={styles.unitInput}>
          <input
            className={styles.input}
            type="number"
            value={draftHeight && Math.ceil(draftHeight)}
            onChange={setDraftHeight}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyPress={handleOnEnter}
            ref={inputElement}
          />

          <KompisText theme={SkapaTheme} className={styles.label}>
            {useMetricMeasures
              ? translate(t.MEASURE_VALUE_CM)
              : translate(t.MEASURE_VALUE_IN)}
          </KompisText>
        </div>
      </div>
    </div>
  );
};

export default CeilingInput;
